<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer005">
<p class="chap-number-new ParaOverride-2"><span class="CharOverride-5">Islandport Press</span></p>
<p class="Normal"><span class="CharOverride-6">PO Box 10</span></p>
<p class="Normal"><span class="CharOverride-6">Yarmouth, Maine 04096 </span></p>
<p class="Normal"><span class="CharOverride-6">www.islandportpress.com </span></p>
<p class="Normal"><span class="CharOverride-6">books@islandportpress.com</span></p>
<p class="Normal"><span class="CharOverride-6">Copyright © 2018 Sarah Marie Aliberti Jette</span></p>
<p class="Normal"><span class="CharOverride-6">First Islandport Press edition published May 2018.</span></p>
<p class="Normal"><span class="CharOverride-6">All Rights Reserved.</span></p>
<p class="Normal"><span class="CharOverride-6">This is a work of fiction. Names, characters, businesses, places, events, and incidents are either the products of the author’s imagination or used in a fictitious manner. Any resemblance to actual persons, living or dead, or actual events is purely coincidental.</span></p>
<p class="Normal"><span class="CharOverride-6">ISBN: 978-1-944762-41-4 </span></p>
<p class="Normal"><span class="CharOverride-6">ISBN: 978-1-944762-46-9 (ebook)</span></p>
<p class="Normal"><span class="CharOverride-6">Library of Congress Control Number: 2017952157</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-7">Dean L. Lunt, Publisher</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-7">Cover and book design: Teresa Lagrange, Islandport Press</span></p>
<p class="Normal"><span class="Character-Style-1 CharOverride-7">Printed in the USA by Versa Press </span></p>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-2" id="_idContainer006">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-2" id="_idContainer007">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame _idGenObjectStyleOverride-1" id="_idContainer008">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// what_wind_can_tell_you_interior_12_pt2.vue?2bcb1982